import React from 'react';
import styled from 'styled-components';

import { Container } from '../../Hoc/elements';
import StickySidebar from '../../Components/Layout/StickySidebar';
import BoutiqueProfile from './BoutiqueProfile';
import MyBoutique from './MyBoutique';

const Boutique = () => (
  <Page>
    <Container>
      <Header>
        <h1>Ma vitrine</h1>
      </Header>
      <HomeLayout>
        <StickySidebar>
          <BoutiqueProfile />
        </StickySidebar>
        <MainColumn>
          <MyBoutique />
        </MainColumn>
      </HomeLayout>
    </Container>
  </Page>
);

const Page = styled.main`
  min-height: calc(100vh - 5rem);
  padding: clamp(1rem, 3vw, 2.5rem) 0 5rem;
  background: var(--color-background);
  color: var(--color-text);
`;

const Header = styled.header`
  margin-bottom: 1.25rem;
  padding: clamp(1rem, 2.5vw, 1.45rem);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-xl);
  background: linear-gradient(135deg, #fff 0%, #fbf7f1 100%);
  box-shadow: var(--shadow-xs);

  h1 { margin: 0; font-size: clamp(1.65rem, 4vw, 2.35rem); }
  p { margin: 0.65rem 0 0; color: var(--color-text-muted); line-height: 1.5; }
`;

const HomeLayout = styled.div`
  display: grid;
  grid-template-columns: minmax(17rem, 18rem) minmax(0, 1fr);
  gap: clamp(1rem, 2vw, 1.5rem);
  align-items: start;

  @media (max-width: 74rem) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

const MainColumn = styled.section`
  min-width: 0;
  align-self: start;
`;

export default Boutique;
